// extracted by mini-css-extract-plugin
export default {"container":"legislation_card-module__container--1ib7d","dates":"legislation_card-module__dates--3LrTg","complement":"legislation_card-module__complement--1d9gC"};